'use strict';

export default class LoginController {
  user = {
    name: '',
    username: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state) {
    this.Auth = Auth;
    this.$state = $state;
    Auth.isLoggedIn().then(data => {
      console.log(data);
      if (_.isArray(data) && data[0] === 'ROLE_ADMIN') {
        this.$state.go('main.home');
      }
    });
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        username: this.user.username,
        password: this.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          this.$state.go('main.home');
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js